module.exports = __webpack_public_path__ + "img/ntpt.f9b91a9d.png";